import { FC, useCallback, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useAppDispatch } from 'shared/hooks';
import { selectLocationSwitcherData } from 'shared/selectors/geo';
import { selectRegions } from 'shared/selectors/regions';
import { LocationSwitcherAutocompleteContainer } from '../AutocompleteContainer';
import { Areas } from '../../../../../../packages/GeoComponents/shared/components/LocationSwitcher/areas';
import { Breadcrumbs } from '../../../../../../packages/GeoComponents/shared/components/LocationSwitcher/breadcrumb';
import { Capitals } from '../../../../../../packages/GeoComponents/shared/components/LocationSwitcher/capitals';
import { ILocation, TLocation } from 'shared/types/location';
import { selectCity, selectRegion, loadLocationSwitcherData } from 'shared/thunks/geo/locationSwitcher';
import { Spinner } from '@cian/ui-kit';
import style from '../../../../../../packages/GeoComponents/shared/components/LocationSwitcher/LocationSwitcher.css';
import { clearLocationSwitcherData } from 'shared/slices/geo';

export const LocationSwitcherModalContainerV2: FC = () => {
  const dispatch = useAppDispatch();

  const { selectedRegion, selectedCity, isCitiesLoading, cities } = useSelector(selectLocationSwitcherData);
  const regions = useSelector(selectRegions);

  useEffect(() => {
    dispatch(loadLocationSwitcherData());
  }, [dispatch]);

  const handleCountrySelect = useCallback(() => {
    dispatch(clearLocationSwitcherData());
  }, [dispatch]);

  const handleRegionSelect = useCallback(
    (region: TLocation) => {
      dispatch(selectRegion(region));
    },
    [dispatch],
  );

  const handleCitySelect = useCallback(
    (city: ILocation) => {
      dispatch(selectCity(city));
    },
    [dispatch],
  );

  return (
    <>
      <LocationSwitcherAutocompleteContainer />
      <Breadcrumbs
        selectedCity={selectedCity}
        selectedRegion={selectedRegion}
        regions={regions}
        onCitySelected={handleCitySelect}
        onCountrySelected={handleCountrySelect}
        onRegionSelected={handleRegionSelect}
      />
      <div className={style['location-switcher']}>
        {isCitiesLoading && (
          <div className={style['preloader-wrapper']}>
            <Spinner size={50} />
          </div>
        )}
        <Capitals
          selectedCity={selectedCity}
          selectedRegion={selectedRegion}
          regions={regions}
          onRegionSelected={handleRegionSelect}
        />
        {(selectedCity || selectedRegion) && (
          <Areas
            areas={cities}
            onSelected={handleCitySelect}
            selectedCity={selectedCity}
            selectedRegion={selectedRegion}
            onRegionSelected={handleRegionSelect}
          />
        )}
        {!(selectedCity || selectedRegion) && (
          <Areas areas={regions} onSelected={handleRegionSelect} onRegionSelected={handleRegionSelect} />
        )}
      </div>
    </>
  );
};
